<!-- cv-rl -->
<template>
  <div class="mentee-cv-rl">
    <ul v-if="cvList.length>0 || rlList.length>0">
    <template v-if="cvStatus">
      <li v-for="(item, index) in cvList"
          :key="`cv${index}`">
        <zlr-card-service title="Curriculum Vitae"
                          style="width: 400px;"
                          kind="CV"
                          :explainList="item.backLogs|backLogsFilters"
                          circle="warning"
                          :dotted=true
                          :dottedList="item.emEdit | dottedfilter"
                          @click="linkHandle(item,'CV')">
          <div>CV {{(index+1)|fillZero}}</div>
        </zlr-card-service>
      </li>
  </template>
  <template v-if="rlStatus">
      <li v-for="(item, index) in rlList"
          :key="`rl${index}`">
        <zlr-card-service title="Reference Letter"
                          style="width: 400px;"
                          kind="CV"
                          bgText="RL"
                          :explainList="item.backLogs|backLogsFilters"
                          circle="warning"
                          :dotted=true
                          @click="linkHandle(item,'RL')"
                          :dottedList="item.emEdit | dottedfilter">
          <div>RL {{(index+1)|fillZero}}</div>
        </zlr-card-service>
      </li>
    </template>
    </ul>
    <zlr-empty v-else></zlr-empty>
  </div>
</template>

<script>
// api
import { getMaterialCVlist, getMaterialRLlist } from '@/api/material'
// components
import ZlrCardService from '_c/card-service/card-service'
import ZlrEmpty from '_c/empty/empty'
export default {
  name: 'mentee-cv-rl',
  components: {
    ZlrCardService,
    ZlrEmpty
  },
  data () {
    return {
      num: this.$route.params.id,
      cvStatus: true,
      rlStatus: true,
      cvList: [],
      rlList: []
    }
  },
  computed: {},
  mounted () {
    this.getMaterialCVlist()
    this.getMaterialRLlist()
  },
  methods: {
    getMaterialCVlist () {
      getMaterialCVlist({
        num: this.num
      }).then(res => {
        this.cvList = res.data.model.bills
        if (res.data.model.bills[0].onlyExpert) {
          this.cvStatus = false
        }
      })
    },
    getMaterialRLlist () {
      getMaterialRLlist({
        num: this.num
      }).then(res => {
        this.rlList = res.data.model.bills
        if (res.data.model.bills[0].onlyExpert) {
          this.rlStatus = false
        }
      })
    },
    linkHandle ({ id, onlyExpert }, type) {
      let name = type === 'CV' ? 'mentee-cvrl-cv-detail' : 'mentee-cvrl-rl-detail'
      this.$router.push({
        name,
        query: {
          billId: id,
          type: onlyExpert
        }
      })
    }
  },
  filters: {
    backLogsFilters (logs) {
      if (logs.length === 0) return []
      let arr = []
      logs.forEach(item => {
        arr.push({ title: item.content, color: '#85A5FF' })
      })
      return arr
    },
    dottedfilter (emEdit) {
      if (emEdit.length === 0) return []
      let arr = []
      let smEditActvie = emEdit.filter(item => item.status === 'EDITED').length
      arr.push({
        conNum: emEdit.length,
        activeNum: smEditActvie
      })
      return arr
    }
  }
}
</script>
<style lang='less' scoped>
</style>
